import { render, staticRenderFns } from "./RevenueSharingForm.vue?vue&type=template&id=775a7eb9&scoped=true"
import script from "./RevenueSharingForm.vue?vue&type=script&lang=js"
export * from "./RevenueSharingForm.vue?vue&type=script&lang=js"
import style0 from "./RevenueSharingForm.vue?vue&type=style&index=0&id=775a7eb9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a7eb9",
  null
  
)

export default component.exports